<template>
  <s-modal
    v-model="showModal"
    class="help-alarm-modal"
    size="lg"
    ok-only
    :ok-title="$t('actions.close')"
    title=""
    @ok="closeModal"
    :html="true"
  >
    <b-container>
      <b-row class="align-items-center title">
        <b-col class="d-flex align-items-center">
          <h1 class="mb-4">{{ modalTitle }}</h1>
          <i class="fas fa-info-circle informationIcon mb-4"></i>
        </b-col>
      </b-row>
      <b-row class="justify-content-center mb-4 mt-4">
        <b-col cols="12">
          <b-card class="text-center variables-and-reference">
            <span>{{
              $t('reports.alarms-and-warnings.help.messages.MI001')
            }}</span>
          </b-card>
        </b-col>
      </b-row>
      <s-table :fields="statusFields" :items="statusItems">
        <template #cell(status)="data">
          <strong>{{ data.item.status }}</strong>
        </template>
      </s-table>
      <b-row class="mb-4 mt-4 p-0 ma-0 align-items-center">
        <b-col cols="12">
          <b-card class="p-0 ma-0 variables-and-reference">
            <b-col class="d-flex align-items-center p-0 ma-0">
              <i class="fas fa-sync primary syncIcon"></i>
              <strong class="subtitle">{{
                $t('reports.alarms-and-warnings.help.messages.MI002')
              }}</strong>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
      <s-table :fields="cycleFields" :items="cycleItems">
        <template #cell(cycle)="data">
          <strong class="text-start">{{ data.item.cycle }}</strong>
        </template>
        <template #cell(description)="data">
          <div v-html="getFormattedDescription(data.item)"></div>
        </template>
      </s-table>
      <b-row class="mb-4 mt-4 p-0 ma-0 align-items-center">
        <b-col cols="12">
          <b-card class="p-0 ma-0 variables-and-reference">
            <b-col class="d-flex align-items-center p-0 ma-0">
              <i class="fas fa-sync primary syncIcon"></i>
              <strong class="subtitle">{{
                $t('reports.alarms-and-warnings.help.messages.MI003')
              }}</strong>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="justify-content-center mb-4 mt-4">
        <b-col cols="12">
          <b-card class="text-center variables-and-reference">
            <span>{{
              $t('reports.alarms-and-warnings.help.messages.MI004')
            }}</span>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
import translate from '@/services/translate';

export default {
  name: 'HelpModal',
  data: () => ({
    showModal: false,
    statusFields: [
      {
        key: 'status',
        label: translate('reports.alarms-and-warnings.help.status'),
      },
      {
        key: 'description',
        label: translate('reports.alarms-and-warnings.help.description'),
        class: 'text-start',
      },
    ],
    cycleFields: [
      {
        key: 'cycle',
        label: translate('reports.alarms-and-warnings.help.cycle'),
      },
      {
        key: 'description',
        label: translate('reports.alarms-and-warnings.help.description'),
        class: 'text-start',
      },
    ],
    statusItems: [
      {
        status: translate(
          'reports.alarms-and-warnings.help.statusItemField.acted',
        ),
        description: translate(
          'reports.alarms-and-warnings.help.statusItemDescription.acted',
        ),
      },
      {
        status: translate(
          'reports.alarms-and-warnings.help.statusItemField.normalized',
        ),
        description: translate(
          'reports.alarms-and-warnings.help.statusItemDescription.normalized',
        ),
      },
      {
        status: translate(
          'reports.alarms-and-warnings.help.statusItemField.recognized',
        ),
        description: translate(
          'reports.alarms-and-warnings.help.statusItemDescription.recognized',
        ),
      },
    ],
    cycleItems: [
      {
        cycle: translate(
          'reports.alarms-and-warnings.help.cycleItemField.entry',
        ),
        description: translate(
          'reports.alarms-and-warnings.help.cycleItemDescription.entry',
        ),
      },
      {
        cycle: translate(
          'reports.alarms-and-warnings.help.cycleItemField.maintenance',
        ),
        description: translate(
          'reports.alarms-and-warnings.help.cycleItemDescription.maintenance',
        ),
        cycleValues: {
          value1: translate(
            'reports.alarms-and-warnings.help.cycleItemDescription.maintenance-value-one',
          ),
          value2: translate(
            'reports.alarms-and-warnings.help.cycleItemDescription.maintenance-value-two',
          ),
        },
      },
      {
        cycle: translate(
          'reports.alarms-and-warnings.help.cycleItemField.reentrance',
        ),
        description: translate(
          'reports.alarms-and-warnings.help.cycleItemDescription.reentrance',
        ),
      },
      {
        cycle: translate(
          'reports.alarms-and-warnings.help.cycleItemField.new-cycle',
        ),
        description: translate(
          'reports.alarms-and-warnings.help.cycleItemDescription.new-cycle',
        ),
      },
      {
        cycle: translate(
          'reports.alarms-and-warnings.help.cycleItemField.entry-date',
        ),
        description: translate(
          'reports.alarms-and-warnings.help.cycleItemDescription.entry-date',
        ),
      },
      {
        cycle: translate(
          'reports.alarms-and-warnings.help.cycleItemField.ignore-event',
        ),
        description: translate(
          'reports.alarms-and-warnings.help.cycleItemDescription.ignore-event',
        ),
      },
    ],
  }),
  methods: {
    show() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    getFormattedDescription(item) {
      let { description } = item;

      if (item.cycleValues) {
        const cycleList = Object.keys(item.cycleValues)
          .map(key => `<li>${item.cycleValues[key]}</li>`)
          .join('');
        description += `<ul>${cycleList}</ul>`;
      }

      return description;
    },
  },
  computed: {
    modalTitle() {
      return translate('alarms-and-warnings.help.title');
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"
.variables-and-reference
  background-color: var(--color-custom-light)

.informationIcon
  font-size: 1.5em
  margin-left: 10px

.syncIcon
  font-size: 1.5em
  margin-right: 10px
  color: var(--color-primary)

.subtitle
  font-size: 1.1em

.s-table
  border: 1px solid var(--color-table-header-bg) !important
  border-radius: 5px !important
  ::v-deep
    th, td
      text-align: left !important
      border: 3px solid var(--color-background-light) !important
    th:nth-child(1),
    td:nth-child(1)
      min-width: 200px !important
    td:nth-child(2)
      font-size: 0.9em !important
</style>
